module.exports = __webpack_public_path__ + "static/media/database.8029190e.svg";